import { OrderSchedule } from "./orderSchedule";

export interface IOrderShipping {
    scheduleList: Array<OrderSchedule>;
    shippingFirstName?: string;
    shippingLastName?: string;
    shippingAddress?: string;
    shippingDistrict?: string;
    shippingSubDistrict?: string;
    shippingProvince?: string;
    shippingPostcode?: string;
    shippingLat?: number;
    shippingLon?: number;
    shippingPhone?: string;
    shippingEmail?: string;
    shippingType?: string;
}

export class OrderShipping implements IOrderShipping {
    scheduleList: OrderSchedule[] = [];
    shippingFirstName?: string;
    shippingLastName?: string;
    shippingAddress?: string;
    shippingDistrict?: string;
    shippingSubDistrict?: string;
    shippingProvince?: string;
    shippingPostcode?: string;
    shippingLat?: number;
    shippingLon?: number;
    shippingPhone?: string;
    shippingEmail?: string;
    shippingType?: string;

    constructor(data: IOrderShipping) {
        if (data.shippingEmail === null) {
            this.scheduleList = (data.scheduleList.map((item) => new OrderSchedule(item)))
            this.shippingFirstName = (data.shippingFirstName)
            this.shippingLastName = data.shippingLastName
            this.shippingAddress = data.shippingAddress
            this.shippingDistrict = data.shippingDistrict
            this.shippingSubDistrict = data.shippingSubDistrict
            this.shippingProvince = data.shippingProvince
            this.shippingPostcode = data.shippingPostcode
            this.shippingLat = data.shippingLat
            this.shippingLon = data.shippingLon
            this.shippingPhone = data.shippingPhone
            // this.shippingEmail = data.shippingEmail
            this.shippingType = data.shippingType
        } else {
            this.scheduleList = (data.scheduleList.map((item) => new OrderSchedule(item)))
            this.shippingFirstName = (data.shippingFirstName)
            this.shippingLastName = data.shippingLastName
            this.shippingAddress = data.shippingAddress
            this.shippingDistrict = data.shippingDistrict
            this.shippingSubDistrict = data.shippingSubDistrict
            this.shippingProvince = data.shippingProvince
            this.shippingPostcode = data.shippingPostcode
            this.shippingLat = data.shippingLat
            this.shippingLon = data.shippingLon
            this.shippingPhone = data.shippingPhone
            this.shippingEmail = data.shippingEmail
            this.shippingType = data.shippingType
        }

    }

}